import React from 'react';

import { useEditor } from '@toasttab/sites-components';
import { ContainsEditableProps } from '@toasttab/sites-components/dist/types/components/editor_context/types';

import { BaseSectionFieldsFragment, LoyaltySignupSectionFieldsFragment, PaddingEnum } from 'src/apollo/sites';

import { getBackgroundColorOrImageModule, getSectionPaddingModule } from 'shared/components/common/editor_context/editableUtils';

import { BetterTogetherSection } from 'public/components/default_template/better_together_section/BetterTogetherSection';
import { useThemeColorScheme } from 'public/components/default_template/meta/useTheme';
import { getSuccessHeader, LOYALTY_SIGNUP_CONTENT, useLoyaltyContext } from 'public/components/pages/loyalty_page/LoyaltyPage';


type LoyaltyWidgetProps = {
  section: LoyaltySignupSectionFieldsFragment & BaseSectionFieldsFragment
} & ContainsEditableProps

export const LoyaltySignupSection = ({ editPath, ...props }: LoyaltyWidgetProps) => {
  const {
    onSubmit,
    programDescription,
    useEmail,
    submitState,
    programName
  } = useLoyaltyContext();
  const { useEditableRef } = useEditor();
  const getColorFromTheme = useThemeColorScheme();

  const { editableRef } = useEditableRef<HTMLDivElement>({
    name: 'loyalty signup section',
    actions: ['move-up', 'move-down', 'duplicate', 'delete'],
    schema: {
      fields: [
        getSectionPaddingModule(editPath, PaddingEnum.Medium),
        getBackgroundColorOrImageModule(editPath, getColorFromTheme(theme => theme.colorScheme.surface.default, '#ffffff'), props?.section?.backgroundImage)
      ]
    },
    path: editPath
  });

  const headerInfo = {
    content: props.section.loyaltySignupHeader || LOYALTY_SIGNUP_CONTENT.defaultHeader,
    editPath: `${editPath}.loyaltySignupHeader`
  };

  const subheaderInfo = {
    content: programDescription,
    editPath: undefined // not editable.
  };

  return (
    <div className={'loyaltySignupSection'} aria-live={'polite'}>
      <BetterTogetherSection
        editableRef={editableRef}
        isSection={true}
        submitState={submitState}
        onSubmit={onSubmit}
        successLine1={getSuccessHeader(programName)}
        successLine2={LOYALTY_SIGNUP_CONTENT.successLine2}
        errorLine1={LOYALTY_SIGNUP_CONTENT.errorLine1}
        errorLine2={LOYALTY_SIGNUP_CONTENT.errorLine2}
        header={headerInfo}
        subheader={subheaderInfo}
        inputType={useEmail ? 'email' : 'phone'}
        disclaimer={
          <>
            {useEmail
              ? LOYALTY_SIGNUP_CONTENT.emailDisclaimer :
              LOYALTY_SIGNUP_CONTENT.phoneDisclaimer}
          </>
        } />
    </div>
  );
};
